import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  types?: string[];
  defaultValues?: any;
}

export default function FormSeparation({ defaultValues, ...props }: Props) {
  const { handleSubmit, control, register, errors } = useForm({
    defaultValues: replaceDefaultValues(
      {
        reservedPrice: '',
        reservedDays: '',
      },
      defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Separación de la propiedad</h1>

      <p>
        Elige un valor de separación y un número de días máximo donde el
        comprador podrá ejercer la compra una vez haya pagado el valor de
        separación
      </p>

      <FormElement
        name="reservedPrice"
        label="Valor de separación*"
        subLabel="Entre $50,000 Y $100,000"
        control={control}
        elementType="price"
        rules={{ required: true, min: 50000, max: 100000 }}
        error={
          errors.reservedPrice && 'Valor incorrecto. (Entre $50,000 Y $100,000)'
        }
      />

      <FormElement
        name="reservedDays"
        label="Número de días*"
        placeholder="Número de días"
        inputRef={register({ required: true })}
        elementType="select"
        error={errors.reservedDays}
        options={[
          { name: '-', value: '' },
          { name: '5 días', value: '5' },
          { name: '10 días', value: '10' },
          { name: '20 días', value: '20' },
          { name: '30 días', value: '30' },
        ]}
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
